import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {HttpClient}from '@angular/common/http';
import { Csp5060Class } from '../../CSPClass/CSP5060/csp5060-class';
import { environment } from '../../../../../../../src/environments/environment';
import { get } from 'lodash';


@Injectable({
  providedIn: 'root'
})
export class Csp5060Service {
   baseUrl: string=  environment.baseUrl + 'CSP5060/';
  constructor(private http:HttpClient) { }

HolidayList():Observable<any>
      {         
          return this.http.get<any>(this.baseUrl+'HolidayList');
      }
  
}
